import React from 'react';

const BetaIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M7.99999 0L4.38365 3.61635L7.99999 7.2327L11.6163 3.61635L7.99999 0ZM3.61633 4.38379L0 8.00014L3.61633 11.6165L7.23266 8.00014L3.61633 4.38379ZM4.38365 12.3839L7.99999 8.76758L11.6163 12.3839L7.99999 16.0003L4.38365 12.3839ZM12.3836 4.38379L8.76731 8.00014L12.3836 11.6165L16 8.00014L12.3836 4.38379Z"
                  fill="black"/>
        </svg>

    );
};

export default BetaIcon;
